import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    outline: none;
    border: none;
    font-family: 'Museo Sans Cyrl', sans-serif
  }

  body, .grid {
    margin: 0;
  }

  a {
    text-decoration: none;
  }
  
  .p-button-label {
    font-weight: 100;
  }
  
  .p-button.hide {
    display: none;
  }

  .p-multiselect-header {
    position: relative;

    .p-multiselect-close {
      display: none;
    }

    .p-checkbox::after {
      content: "Выбрать всё";
      position: absolute;
      bottom: 1px;
      left: 30px;
      width: max-content;
      font-family: 'Museo Sans Cyrl',sans-serif;
      font-size: 16px;
      font-weight: 400;
      color: #495057;
    }
  }

  .p-inputnumber-input {
    width: 115px;
  }
`;

export default GlobalStyles;
